import React, { Component } from 'react';
import Request from 'superagent';

export default class DateFilter extends Component {
  onChange(event) {
    this.props.onDateRangeChange(event.target.value);
  }
  render() {
    return (
      <select onChange={this.onChange.bind(this)} value={this.props.activeDateRangeFilter} className="form-control">
          {
            this.props.dateRanges.map((dateRange, index) => {
              return <option key={index} value={dateRange.value}>{dateRange.name}</option>
            })
          }
      </select>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/date-filter.js
 **/